/**
 * @module Tests
 * @description Some handy test for common issues.
 */

/**
 * @function isJSON
 * @description
 */
const isJSON = ( str ) => {
  try {
    JSON.parse( str );
  } catch ( e ) {
    if ( process.env.NEXT_PUBLIC_ENVIRONMENT === 'local' ) {
      console.error( 'JSON parsing failed:', e );
    }
    return false;
  }

  return true;
};


/**
 * @function isEmail
 * @description
 */
const isEmail = ( str ) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test( String( str ).toLowerCase() );
};


/**
 * @function canLocalStore
 * @description
 */
const canLocalStore = () => {
  let mod;
  let result = false;

  try {
    mod = new Date();
    localStorage.setItem( mod, mod.toString() );

    result = localStorage.getItem( mod ) === mod.toString();
    localStorage.removeItem( mod );
    return result;
  } catch ( error ) {
    if ( process.env.NEXT_PUBLIC_ENVIRONMENT === 'local' ) {
      console.error( 'JSON parsing failed:', error );
    }
    return result;
  }
};

const android = /(android)/i.test( navigator.userAgent );
const chrome = !! window.chrome;
const firefox = typeof InstallTrigger !== 'undefined';
const ie = /* @cc_on!@ */ false || document.documentMode || false;
const edge = ! ie && !! window.StyleMedia;
const ios = !! navigator.userAgent.match( /(iPod|iPhone|iPad)/i );
const iosMobile = !! navigator.userAgent.match( /(iPod|iPhone)/i );
const opera = !! window.opera || navigator.userAgent.indexOf( ' OPR/' ) >= 0;
const safari = Object.prototype.toString.call( window.HTMLElement ).indexOf( 'Constructor' ) > 0 || ! chrome && ! opera && window.webkitAudioContext !== 'undefined'; /* eslint-disable-line no-mixed-operators */
const os = navigator.platform;

/**
 * @function browserTests
 * @description
 */
const browserTests = () => ( {
  android,
  chrome,
  edge,
  firefox,
  ie,
  ios,
  iosMobile,
  opera,
  safari,
  os
} );

export {
  isJSON,
  isEmail,
  canLocalStore,
  browserTests
};
